﻿import Valg from '../../../Shared/Scripts/Models/Valg';

export interface ValgState {
    aInfo?: Valg<string>;
    bInntektOgBarn?: boolean;
    cInntekt?: number;
    cAntallBarn?: number;
    visVilkar: boolean;
}

export const UPDATE_VALG = 'UPDATE_VALG';
export const TOGGLE_VILKAR = 'TOGGLE_VILKAR';

interface UpdateValgAction {
    type: typeof UPDATE_VALG;
    payload: Partial<ValgState>;
}

export interface ToggleVilkarAction {
    type: typeof TOGGLE_VILKAR;
}

export type ValgStateActionTypes = UpdateValgAction | ToggleVilkarAction;
